"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = Sidebar;
exports.SidebarItem = SidebarItem;
exports.SidebarNavLink = SidebarNavLink;
exports.SidebarLink = SidebarLink;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-object-type */
// https://github.com/constgenius/sidebarReact/blob/main/src/components/Sidebar.jsx
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_router_dom_2 = require("react-router-dom");
const SidebarContext = (0, react_1.createContext)({
    expanded: false
});
function Sidebar(props) {
    const { children } = props;
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)("aside", { className: "h-full", children: (0, jsx_runtime_1.jsx)("nav", { className: "h-full flex flex-col bg-white", children: (0, jsx_runtime_1.jsx)(SidebarContext.Provider, { value: { expanded: expanded }, children: (0, jsx_runtime_1.jsx)("ul", { className: "flex-1 px-1", children: children }) }) }) }));
}
function SidebarItem(props) {
    const { icon, text, active, onClick } = props;
    const expanded = (0, react_1.useContext)(SidebarContext).expanded;
    //const tooltipClasses = `text-sm bg-lime-100 text-lime-800 absolute left-full rounded-md px-2 py-1 ml-6 invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0`;
    //const activeClass = "bg-gradient-to-tr from-lime-200 to-lime-100 text-lime-800";
    const activeClass = "bg-[#e3ede0]";
    //const hoverClass = "hover:bg-lime-50 text-gray-600";
    const hoverClass = "";
    return ((0, jsx_runtime_1.jsx)("li", { className: `relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group ${active ? `${activeClass}` : `${hoverClass}`}`, children: (0, jsx_runtime_1.jsx)("button", { className: "flex flex-row justify-start items-center", onClick: onClick, children: (0, jsx_runtime_1.jsx)("img", { src: icon, width: 32, height: 32, alt: "", title: text }) }) }));
}
/*
export function SidebarLink(props: SidebarLinkProps) {
    const { icon, text, active, to } = props;
    const navigate = useNavigate();
    return (
        <SidebarItem icon={icon} text={text} active={active} onClick={() => {
            if (to) {
                navigate(`${to}`);
            }
        }} />
    );
}
*/
function SidebarNavLink(props) {
    const { icon, text, active, to } = props;
    const navigate = (0, react_router_dom_2.useNavigate)();
    const currentLocation = (0, react_router_dom_1.useLocation)();
    const activeClass = "bg-[#e3ede0]";
    return ((0, jsx_runtime_1.jsx)("li", { className: "flex flex-row items-center my-1", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { onClick: () => {
                if (to == currentLocation.pathname) {
                    // window.location.reload();
                    navigate(0); // refresh current page
                }
            }, to: to, className: ({ isActive }) => [
                "px-2 py-2 rounded-md cursor-pointer",
                isActive ? `${activeClass}` : "",
            ].join(" "), children: (0, jsx_runtime_1.jsx)("img", { src: icon, width: 32, height: 32, alt: "", title: text }) }) }));
}
function SidebarLink(props) {
    const { icon, text, active, to } = props;
    const navigate = (0, react_router_dom_2.useNavigate)();
    const currentLocation = (0, react_router_dom_1.useLocation)();
    const classes = `px-2 py-2 rounded-md cursor-pointer ${active ? "bg-[#e3ede0]" : ""}`;
    const handleClick = () => {
        //console.log(`currentLocation=${currentLocation.pathname}, to=${to}`);
        if (currentLocation.pathname == to) {
            window.history.replaceState({}, "", `${to}`); // note: does not trigger a page reload
            window.location.reload();
        }
        else if (to) {
            navigate(`${to}`);
        }
    };
    return ((0, jsx_runtime_1.jsx)("li", { className: "flex flex-row items-center my-1", children: (0, jsx_runtime_1.jsx)("div", { className: classes, onClick: handleClick, children: (0, jsx_runtime_1.jsx)("img", { src: icon, width: 32, height: 32, alt: "", title: text }) }) }));
}
